import { render } from "./dialog-check-detail.vue?vue&type=template&id=13f617c1&scoped=true&ts=true"
import script from "./dialog-check-detail.vue?vue&type=script&lang=ts"
export * from "./dialog-check-detail.vue?vue&type=script&lang=ts"

import "./dialog-check-detail.vue?vue&type=style&index=0&id=13f617c1&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f617c1"]])

export default __exports__